import React from 'react'
import { COLORES } from '../../../../../config/colores'
import moment from 'moment'
import TableValueAction from '../../../../MuiTable/components/TableValueAction'
import TablaConsultaCodigoDeCupos from '../../../../Cupos/containers/consultaCodigoDeCupos/containers/TablaConsultaCodigoDeCupos'
import TablaPosiblesArribos from '../../posiblesArribos/containers/TablaPosiblesArribos'
import { Tooltip } from '@material-ui/core'
import TablaCuposSinConsumir from '../../cuposSinConsumir/containers/TablaCuposSinConsumir'

export const COLUMNS = [
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      filterType: 'checkbox',
      sort: true,
      sticky: true,
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      }),
      customBodyRender: (c) => {
        return (
          <Tooltip title='No se distingue por variedad'>
            <p style={{ color: COLORES.grey.dark }}> {c}</p>
          </Tooltip>
        )
      }
    }
  },
  {
    name: 'entry',
    label: 'Asignados',
    options: {
      filter: false,
      sort: false,
      total: true,
      tooltipLabel: 'Cupos del día',
      customBodyRender: (entry) => {
        const value = entry.asignados
        const fecha = moment(new Date()).format('YYYY-MM-DD')
        const fechaFiltro = fecha
        const filtroInicial = [
          {
            name: 'fecha',
            filterList: [entry.fechaCupo]
          }
        ]

        return (
          (value > 0)
            ? <TableValueAction
              value={value}
              title='Cupos asignados'
              content={<TablaConsultaCodigoDeCupos
                showTitle={false}
                filtroInicial={filtroInicial}
                fechaFiltro={fechaFiltro}
                cerealFiltro={entry.cereal}
                totalizador
              />}
            />
            : <div
              style={{
                color: COLORES.grey.dark,
                fontSize: '1rem',
                width: '100%',
                fontWeight: 'bold'
              }}
            >
              {value}
            </div>
        )
      }
    }
  },
  {
    name: 'entry',
    label: 'En terminal',
    options: {
      filter: false,
      sort: false,
      total: true,
      tooltipLabel: 'Todo lo ingresado',
      customBodyRender: (entry) => {
        const value = entry.totalEnTerminal
        const fecha = moment(new Date()).format('YYYY-MM-DD')
        const fechaFiltro = moment(fecha).add(10, 'days').format('YYYY-MM-DD')
        const fechaDesde = moment(fecha).subtract(3, 'days').format('YYYY-MM-DD')
        const filtroInicial = [
          {
            name: 'cereal',
            filterList: [entry.cereal]
          },
          {
            name: 'estado',
            filterList: ['En Terminal']
          }
        ]

        return (
          (value > 0)
            ? <TableValueAction
              value={value}
              title='Camiones en terminal'
              content={<TablaConsultaCodigoDeCupos
                showTitle={false}
                filtroInicial={filtroInicial}
                fechaFiltro={fechaFiltro}
                fechaDesde={fechaDesde}
                cerealFiltro={entry.cereal}
                arriboFiltro='En Terminal'
              />}
            />
            : <div style={{
              color: COLORES.grey.dark,
              fontSize: '1rem',
              width: '100%',
              fontWeight: 'bold'
            }}
            >
              {value}
            </div>
        )
      }
    }
  },
  {
    name: 'entry',
    label: 'Descargados',
    options: {
      filter: false,
      sort: false,
      total: true,
      tooltipLabel: 'Descargados con cupo del día',
      customBodyRender: (entry) => {
        const value = entry.descargados
        const fecha = moment(new Date()).format('YYYY-MM-DD')
        const filtroInicial = [
          {
            name: 'cereal',
            filterList: [entry.cereal]
          },
          {
            name: 'estado',
            filterList: ['Descargado']
          }
        ]
        return (
          (value > -1)
            ? <TableValueAction
              value={value}
              title=' '
              content={<TablaConsultaCodigoDeCupos
                showTitle={false}
                filtroInicial={filtroInicial}
                fechaFiltro={fecha}
                fechaDesde={fecha}
                cerealFiltro={entry.cereal}
                arriboFiltro='Descargado'
              />}
            />
            : <div style={{
              color: COLORES.grey.dark,
              fontSize: '1rem',
              width: '100%',
              fontWeight: 'bold'
            }}
            >
              {value}
            </div>
        )
      }
    }
  },
  {
    name: 'entry',
    label: 'Rechazados',
    options: {
      filter: false,
      sort: false,
      total: true,
      tooltipLabel: 'Rechazados vigentes',
      customBodyRender: (entry) => {
        const value = entry.totalRechazados
        const fecha = moment(new Date()).format('YYYY-MM-DD')
        const fechaFiltro = fecha
        const fechaDesde = moment(fecha).subtract(2, 'days').format('YYYY-MM-DD')
        const filtroInicial = [
          {
            name: 'cereal',
            filterList: [entry.cereal]
          },
          {
            name: 'estado',
            filterList: ['Rechazado', 'Rechazo administrativo']
          }
        ]

        return (
          (value > 0)
            ? <TableValueAction
              value={value}
              title='Rechazados'
              content={<TablaConsultaCodigoDeCupos
                showTitle={false}
                filtroInicial={filtroInicial}
                fechaFiltro={fechaFiltro}
                fechaDesde={fechaDesde}
                cerealFiltro={entry.cereal}
                //   arriboFiltro={['Rechazado', 'Rechazo administrativo']}
              />}
            />
            : <div style={{
              color: COLORES.grey.dark,
              fontSize: '1rem',
              width: '100%',
              fontWeight: 'bold'
            }}
            >
              {value}
            </div>
        )
      }
    }
  },
  {
    name: 'entry',
    label: 'Sin consumir',
    options: {
      filter: false,
      sort: false,
      total: true,
      tooltipLabel: 'Cupos del día sin consumir',
      customBodyRender: (entry) => {
        const value = entry.sinConsumir
        const fecha = moment(new Date()).format('YYYY-MM-DD')
        const fechaDesde = moment(fecha).subtract(3, 'days').format('YYYY-MM-DD')
        const filtroInicial = [
          {
            name: 'cereal',
            filterList: [entry.cereal]
          },
          {
            name: 'estado',
            filterList: ['Sin consumir']
          }
        ]

        return (
          (value > 0)
            ? <TableValueAction
              value={value}
              title='Sin consumir'
              content={<TablaCuposSinConsumir
                filtroInicial={filtroInicial}
                fechaH={fecha}
                fechaD={fechaDesde}
                cereal={entry.cereal}
              />}
            />
            : <div style={{
              color: COLORES.grey.dark,
              fontSize: '1rem',
              width: '100%',
              fontWeight: 'bold'
            }}
            >
              {value}
            </div>
        )
      }
    }
  },
  {
    name: 'entry',
    label: 'En viaje',
    options: {
      filter: false,
      sort: false,
      total: true,
      tooltipLabel: 'Camiones en viaje con cupo hasta hoy',
      customBodyRender: (entry) => {
        const value = entry.totalEnViaje
        const fecha = moment(new Date()).format('YYYY-MM-DD')
        const fechaFiltro = fecha
        const fechaDesde = moment(fecha).subtract(3, 'days').format('YYYY-MM-DD')
        const filtroInicial = [
          {
            name: 'cereal',
            filterList: [entry.cereal]
          },
          {
            name: 'estado',
            filterList: ['En Viaje']
          }
        ]
        return (
          (value > 0)
            ? <TableValueAction
              value={value}
              title='Total en viaje'
              content={<TablaConsultaCodigoDeCupos
                showTitle={false}
                filtroInicial={filtroInicial}
                fechaFiltro={fechaFiltro}
                fechaDesde={fechaDesde}
                cerealFiltro={entry.cereal}
                arriboFiltro='En Viaje'

              />}
            />
            : <div style={{
              color: COLORES.grey.dark,
              fontSize: '1rem',
              width: '100%',
              fontWeight: 'bold'
            }}
            >
              {value}
            </div>
        )
      }
    }
  },
  {
    name: 'entry',
    label: 'Posible arribo',
    options: {
      filter: false,
      sort: false,
      total: true,
      tooltipLabel: 'Camiones en viaje hasta hoy + Sin consumir del día + Rechazados vigentes hasta hoy ',
      customBodyRender: (entry) => {
        const value = entry.sinConsumir + entry.totalEnViaje + entry.totalRechazados + entry.totalAbandonados
        const fecha = moment(new Date()).format('YYYY-MM-DD')
        const fechaDesde = moment(fecha).subtract(2, 'days').format('YYYY-MM-DD')
        const filtroInicial = [
          {
            name: 'cereal',
            filterList: [entry.cereal]
          }
        ]
        return (
          (value > 0)
            ? <TableValueAction
              value={value}
              title='Posible arribo'
              content={
                <TablaPosiblesArribos
                  fechaD={fechaDesde}
                  filtroInicial={filtroInicial}
                  fechaH={fecha}
                  cerealFiltro={entry.cereal}
                />
              }
            />
            : <div style={{
              color: COLORES.grey.dark,
              fontSize: '1rem',
              width: '100%',
              fontWeight: 'bold'
            }}
            >
              {value}
            </div>
        )
      }
    }
  },
  {
    name: 'porcentajeArribo',
    label: 'Cumplimiento',
    options: {
      filter: false,
      sort: false,
      tooltipLabel: 'Arribados del total asignado',
      customBodyRender: (value) => {
        return (value ? <div style={{
          fontSize: '1.3rem',
          fontWeight: 'bold',
          color: COLORES.grey.dark,
          backgroundColor: '#cec0ff',
          textAlign: 'center',
          borderRadius: '8px'
        }}
        >
          {value} %
        </div>
          : <div style={{ textAlign: 'center' }}> - </div>
        )
      }
    }
  }
]
